import styled from "styled-components";
import css from "@styled-system/css";
import {
  LayoutProps,
  layout,
  display,
  DisplayProps,
  BorderColorProps,
} from "styled-system";

const DashedLine = styled.hr<
  LayoutProps &
    DisplayProps & {
      placement: "start" | "end";
      minContainerWidth: number;
      connectorColor: BorderColorProps["borderColor"];
    }
>`
  height: 0;
  margin: 0;
  ${css({
    border: 0,
    borderLeftColor: "lightest-grey",
    borderLeftStyle: "dashed",
    borderLeftWidth: "border-size-thick",
  })}
  ${(props) =>
    css({
      [`@media only screen and (min-width: ${props.minContainerWidth}px)`]: {
        display: "block",
        width: "100%",
        borerLeft: "none",
        borderTopColor: props.connectorColor,
        borderTopStyle: "dashed",
        borderTopWidth: "border-size-thick",
        marginRight: props.placement === "end" ? "3px" : 0,
      },
    })}
  ${layout}
  ${display}
`;

export default DashedLine;
